// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/sections/Hero';
import ApiDocsSection from '../components/sections/ApiDocsSection';
import ApiInfrastructure from '../components/sections/OurPartners';
import Security from '../components/sections/Security';
import Resources from '../components/sections/Resources';
import Integration from '../components/sections/Integration';
import GettingStarted from '../components/sections/GettingStarted';
import ErpOverview from '../components/sections/ErpOverview';

const Home = () => {
  return (
    <>
      <Hero />
      <ApiDocsSection />
      {/* <section id="ErpOverview">
        <ErpOverview />
      </section> */}
      {/* <section id="security">
        <Security />
        </section> */}
      <section id="resources">
        <Resources />
      </section>
        <section id="infrastructure">
          <ApiInfrastructure />
        </section>
      {/* <section id="integration">
        <Integration />
      </section> */}
      {/* <section id="getting-started">
        <GettingStarted />
      </section> */}
    </>
  );
};

export default Home;